import { IHeadlineProps, IPartial } from './types';

export function useHeadline({ data, onUpdate }: IHeadlineProps) {
  const { headline = '', subheadline = '', mountNodeId, isCenter = false } = data.data;

  const handleHeadlineChange = (headline: string) => {
    handleChange({ headline });
  };

  const handleSubheadlineChange = (subheadline: string) => {
    handleChange({ subheadline });
  };

  const handleChange = (partial: IPartial) => {
    const newObject = {
      ...data,
      data: {
        ...data.data,
        ...partial,
      },
    };

    onUpdate(newObject);
  };

  return {
    headline,
    subheadline,
    mountNodeId,
    handleHeadlineChange,
    handleSubheadlineChange,
    isCenter,
  };
}
